import { InjectionToken } from '@angular/core';

export namespace NOffClick {
    /**
     * Options injection token
     */
    export const CONFIG = new InjectionToken<IConfig>('OFF_CLICK_CONFIG');

    export interface IConfig {
        global: boolean;
    }
}
